import React, { useState } from 'react';
import CustomTitle from 'components/CustomTitle';
import { Card, Col, Row } from 'antd';
import xlsxLogo from 'pictures/xlsx_icon.svg.png'
import pdfLogo from 'pictures/pdf-logo.png'
import HistoricalPdf from './pmv/HistoricalPdf';
import CustomLayout from 'components/Layout';
import Meta from 'antd/es/card/Meta';
import HistoricalSosXlsx from './sos/HistoricalSosXlsx';

interface IDataReport {
    name: string;
    description: string;
    logo: string;
    onClick: () => void;
}

type modalTypes = {
    historicalPmv: boolean;
    graphicEM: boolean;
    historicalEM: boolean;
    historicalSos: boolean;
}

const ReportDownload: React.FC = () => {
    const [modal, setModal] = useState<modalTypes>({ historicalPmv: false, graphicEM: false, historicalEM: false, historicalSos: false });

    const dataReports: IDataReport[] = [
        { name: "Histórico PMV", description: "Reporte de los aspectos históricos del PMV", logo: pdfLogo, onClick: () => setModal({ ...modal, historicalPmv: true }) },
        { name: "Histórico SOS", description: "Reporte del histórico de eventos", logo: xlsxLogo, onClick: () => setModal({ ...modal, historicalSos: true }) },
        // { name: "Estaciones Meteorológicas", description: "Gráfico de estaciones meteorológicas", logo: pdfLogo, onClick: () => setModal({ ...modal, graphicEM: true }) },
        // { name: "Estaciones Meteorológicas", description: "Histórico de estaciones meteorológicas", logo: xlsxLogo, onClick: () => setModal({ ...modal, historicalEM: true }) },
    ];

    return (
        <CustomLayout>
            <CustomTitle title='Reportes' />
            <Row gutter={[16, 16]}>
                {
                    dataReports.map((report, index) => (
                        <Col
                            key={index}
                            xs={24} sm={12} md={8} lg={6} xl={4}
                        >
                            <Card
                                variant="borderless"
                                hoverable
                                cover={<img alt="example" src={report.logo} />}
                                onClick={report.onClick}
                                style={{ height: '420px' }}
                            >
                                <Meta
                                    title={report.name}
                                    description={report.description}
                                />
                            </Card>
                        </Col>
                    ))
                }
            </Row>
            {/* Histórico PMV - PDF */}
            {
                modal.historicalPmv && <HistoricalPdf onClose={() => setModal({ ...modal, historicalPmv: false })} />
            }
            {/* Historico SOS - XSLX */}
            {
                modal.historicalSos && <HistoricalSosXlsx onClose={() => setModal({ ...modal, historicalSos: false })} />
            }
        </CustomLayout>
    );
};

export default ReportDownload;
